import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import WrapperFilter from "../WrapperFilter";
import FilterText from "../FilterText";

interface IFilterRPKEYSEARCH {
  setCondition: Dispatch<SetStateAction<any>>;
}

function FilterRPKEYSEARCH({ setCondition }: IFilterRPKEYSEARCH) {
  const originFilter: { [key: string]: any } = {
    key: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.key) {
      condition.key = filter.key;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="ID (BV)"
        placeholder="Tìm theo ID"
        value={filter.key}
        onSearch={(val) => setFilter({ ...filter, key: val })}
      />
    </WrapperFilter>
  );
}

export default FilterRPKEYSEARCH;
